import { render, staticRenderFns } from "./DxNurseryEgresosReport.vue?vue&type=template&id=210650c8&"
import script from "./DxNurseryEgresosReport.vue?vue&type=script&lang=js&"
export * from "./DxNurseryEgresosReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports